module.exports = __webpack_public_path__ + "img/arrobita_perfil.7275d4ef.png";